// import React from "react";
// import { Layout, Menu, Drawer } from "antd";
// import { Link } from "react-router-dom";
// import { adminMenu, userMenu } from "../Config";

// const { Sider } = Layout;

// const Sidebar = ({
//   collapsed,
//   setCollapsed,
//   mobileOpen,
//   setMobileOpen,
//   isMobile,
//   role = "admin",
// }) => {

//   const menuItems = role === "admin" ? adminMenu : userMenu;

//   const formatMenu = (items) =>
//     items.map((item) =>
//       item.children
//         ? {
//           key: item.key,
//           icon: item.icon,
//           label: item.label,
//           children: formatMenu(item.children),
//         }
//         : {
//           key: item.key,
//           icon: item.icon,
//           label: <Link to={item.path}>{item.label}</Link>,
//         }
//     );

//   const menuContent = (
//     <>
//       <div
//         style={{
//           height: 60,
//           margin: "0 15px 20px",
//           background: "rgba(255,255,255,0.1)",
//           borderRadius: 12,
//           display: "flex",
//           alignItems: "center",
//           justifyContent: "center",
//           color: "#fff",
//           fontWeight: 700,
//           fontSize: 20,
//         }}
//       >
//         Yoga Admin
//       </div>

//       <Menu
//         theme="dark"
//         mode="inline"
//         items={formatMenu(menuItems)}
//         style={{ background: "transparent" }}
//         onClick={() => isMobile && setMobileOpen(false)}
//       />
//     </>
//   );

//   // ✅ Mobile Drawer
//   if (isMobile) {
//     return (
//       <Drawer
//         placement="left"
//         closable={false}
//         onClose={() => setMobileOpen(false)}
//         open={mobileOpen}
//         bodyStyle={{
//           padding: 0,
//           background: "rgba(13, 27, 42, 0.98)",
//         }}
//         width={240}
//       >
//         {menuContent}
//       </Drawer>
//     );
//   }

//   // ✅ Desktop Sidebar
//   return (
//     <Sider
//       trigger={null}
//       collapsible
//       collapsed={!isMobile ? collapsed : false}
//       collapsedWidth={isMobile ? 0 : 80}
//       width={240}
//       breakpoint="lg"
//       onCollapse={(value) => {
//         if (!isMobile && setCollapsed) {
//           setCollapsed(value);
//         }
//       }}
//       style={{
//         background: "rgba(13, 27, 42, 0.95)",
//         height: "100vh",
//         position: "fixed",
//         top: 70,
//         left: 0,
//         zIndex: 1000,
//       }}
//     >
//       {menuContent}
//     </Sider>
//   );
// };

// export default Sidebar;

import React from "react";
import { Layout, Menu, Drawer } from "antd";
import { Link, useLocation } from "react-router-dom";
import { adminMenu, userMenu } from "../Config";

const { Sider } = Layout;

const SIDEBAR_BG =
  "linear-gradient(180deg, #1a0533 0%, #2d1b4e 40%, #1a0533 100%)";

const Sidebar = ({
  collapsed,
  setCollapsed,
  mobileOpen,
  setMobileOpen,
  isMobile,
  role = "admin",
}) => {
  const location = useLocation();
  const menuItems = role === "admin" ? adminMenu : userMenu;

  // Find active key from current path
  const findActiveKey = (items) => {
    for (const item of items) {
      if (item.path && location.pathname === item.path) return item.key;
      if (item.children) {
        const found = findActiveKey(item.children);
        if (found) return found;
      }
    }
    return null;
  };

  const activeKey = findActiveKey(menuItems);

  const formatMenu = (items) =>
    items.map((item) =>
      item.children
        ? {
            key: item.key,
            icon: item.icon,
            label: item.label,
            children: formatMenu(item.children),
          }
        : {
            key: item.key,
            icon: item.icon,
            label: <Link to={item.path}>{item.label}</Link>,
          },
    );

  const menuContent = (
    <div
      style={{
        display: "flex",
        flexDirection: "column",
        height: "100%",
        overflow: "hidden",
      }}
    >
      {/* ── Logo / Brand ── */}
      <div
        style={{
          padding: "28px 20px 20px",
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          gap: 10,
        }}
      >
        {/* Logo circle */}
        <div
          style={{
            width: 64,
            height: 64,
            borderRadius: "50%",
            background: "rgba(255,255,255,0.08)",
            border: "1.5px solid rgba(255,255,255,0.15)",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            overflow: "hidden",
          }}
        >
          <img
            src="/logo192.png"
            alt="logo"
            style={{ width: 60, height: 60, objectFit: "contain" }}
            onError={(e) => {
              e.target.style.display = "none";
            }}
          />
        </div>
        <div
          style={{
            fontSize: 11,
            color: "rgba(255,255,255,0.45)",
            letterSpacing: 1,
          }}
        >
          YogaRefer.Com
        </div>
      </div>

      {/* ── Role label ── */}
      <div
        style={{
          margin: "0 16px 16px",
          background: "rgba(139, 92, 246, 0.25)",
          border: "1px solid rgba(139, 92, 246, 0.4)",
          borderRadius: 10,
          padding: "8px 14px",
          display: "flex",
          alignItems: "center",
          gap: 8,
          justifyContent: "center",
        }}
      >
        {/* <span style={{ fontSize: 16 }}>👑</span> */}
        <span
          style={{
            color: "#c4b5fd",
            fontWeight: 600,
            fontSize: 14,
            textTransform: "uppercase",
            alignItems: "center",
            display: "flex",
            gap: 6,
          }}
        >
          {role === "admin" ? "Admin" : "User"}
        </span>
      </div>

      {/* ── Menu ── */}
      <div
        style={{
          flex: 1,
          overflowY: role === "admin" ? "auto" : "hidden",
          overflowX: "hidden",
        }}
      >
        <style>{`
          .yoga-sidebar .ant-menu-item,
          .yoga-sidebar .ant-menu-submenu-title {
            border-radius: 10px !important;
            margin: 2px 10px !important;
            width: calc(100% - 20px) !important;
            color: rgba(255,255,255,0.65) !important;
            transition: all 0.2s !important;
          }
          .yoga-sidebar .ant-menu-item:hover,
          .yoga-sidebar .ant-menu-submenu-title:hover {
            background: rgba(139, 92, 246, 0.18) !important;
            color: #fff !important;
          }
          .yoga-sidebar .ant-menu-item-selected {
            background: linear-gradient(90deg, #7c3aed, #6d28d9) !important;
            color: #fff !important;
            box-shadow: 0 4px 14px rgba(124, 58, 237, 0.45) !important;
          }
          .yoga-sidebar .ant-menu-item-selected a,
          .yoga-sidebar .ant-menu-item-selected .ant-menu-item-icon {
            color: #fff !important;
          }
          .yoga-sidebar .ant-menu-sub {
            background: transparent !important;
          }
          .yoga-sidebar .ant-menu-submenu-arrow {
            color: rgba(255,255,255,0.4) !important;
          }
          .yoga-sidebar .ant-menu-item a {
            color: inherit !important;
          }
          .yoga-sidebar::-webkit-scrollbar { width: 0px; }
        `}</style>

        <Menu
          className="yoga-sidebar"
          theme="dark"
          mode="inline"
          selectedKeys={activeKey ? [activeKey] : []}
          items={formatMenu(menuItems)}
          style={{
            background: "transparent",
            border: "none",
            padding: "0 0 12px",
          }}
          onClick={() => isMobile && setMobileOpen(false)}
        />
      </div>

      {/* ── Yoga silhouette decoration ── */}
      {!collapsed && (
        <div
          style={{
            padding: "10px 0 0",
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            pointerEvents: "none",
            userSelect: "none",
          }}
        >
          {/* Stars */}
          <div
            style={{
              width: "100%",
              textAlign: "center",
              fontSize: 11,
              color: "rgba(255,255,255,0.2)",
              letterSpacing: 6,
              marginBottom: 4,
            }}
          >
            ✦ ✦ ✦
          </div>

          {/* SVG yoga silhouette */}
          <svg
            viewBox="0 0 160 140"
            width="160"
            height="140"
            style={{ opacity: 0.18, display: "block" }}
          >
            {/* Lotus leaves */}
            <ellipse cx="80" cy="128" rx="60" ry="12" fill="#7c3aed" />
            <ellipse
              cx="50"
              cy="122"
              rx="30"
              ry="10"
              fill="#6d28d9"
              transform="rotate(-20 50 122)"
            />
            <ellipse
              cx="110"
              cy="122"
              rx="30"
              ry="10"
              fill="#6d28d9"
              transform="rotate(20 110 122)"
            />
            {/* Body sitting */}
            <ellipse cx="80" cy="112" rx="22" ry="10" fill="#7c3aed" />
            {/* Torso */}
            <rect x="72" y="80" width="16" height="32" rx="8" fill="#7c3aed" />
            {/* Arms out */}
            <line
              x1="72"
              y1="90"
              x2="44"
              y2="78"
              stroke="#7c3aed"
              strokeWidth="7"
              strokeLinecap="round"
            />
            <line
              x1="88"
              y1="90"
              x2="116"
              y2="78"
              stroke="#7c3aed"
              strokeWidth="7"
              strokeLinecap="round"
            />
            {/* Head */}
            <circle cx="80" cy="68" r="13" fill="#7c3aed" />
            {/* Crown glow */}
            <circle cx="80" cy="52" r="4" fill="#a78bfa" opacity="0.7" />
            <line
              x1="80"
              y1="40"
              x2="80"
              y2="48"
              stroke="#a78bfa"
              strokeWidth="1.5"
              opacity="0.5"
            />
            <line
              x1="68"
              y1="44"
              x2="72"
              y2="50"
              stroke="#a78bfa"
              strokeWidth="1.5"
              opacity="0.5"
            />
            <line
              x1="92"
              y1="44"
              x2="88"
              y2="50"
              stroke="#a78bfa"
              strokeWidth="1.5"
              opacity="0.5"
            />
          </svg>

          {/* Decorative leaf */}
          <div
            style={{
              position: "absolute",
              bottom: 0,
              left: 0,
              width: 80,
              height: 100,
              overflow: "hidden",
              pointerEvents: "none",
            }}
          >
            <svg
              viewBox="0 0 80 100"
              width="80"
              height="100"
              style={{ opacity: 0.12 }}
            >
              <path
                d="M10,100 Q5,60 30,30 Q50,5 70,10 Q60,40 40,60 Q20,80 10,100Z"
                fill="#7c3aed"
              />
              <path
                d="M10,100 Q30,70 50,55"
                stroke="#a78bfa"
                strokeWidth="1"
                fill="none"
                opacity="0.5"
              />
            </svg>
          </div>
        </div>
      )}
    </div>
  );

  const siderStyle = {
    background: SIDEBAR_BG,
    height: "calc(100vh - 70px)",
    position: "fixed",
    top: 70,
    left: 0,
    zIndex: 1000,
    boxShadow: "4px 0 24px rgba(0,0,0,0.4)",
  };

  if (isMobile) {
    return (
      <Drawer
        placement="left"
        closable={false}
        onClose={() => setMobileOpen(false)}
        open={mobileOpen}
        bodyStyle={{ padding: 0, background: SIDEBAR_BG }}
        width={240}
      >
        {menuContent}
      </Drawer>
    );
  }

  return (
    <Sider
      trigger={null}
      collapsible
      collapsed={collapsed}
      collapsedWidth={80}
      width={240}
      style={siderStyle}
    >
      {menuContent}
    </Sider>
  );
};

export default Sidebar;
